"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var React = require("react");
require("./right-download.scss");
var guider_1 = require("./guider");
var stat_1 = require("../stat/stat");
var guider = new guider_1.Guider();
var RightDownload = (function (_super) {
    __extends(RightDownload, _super);
    function RightDownload(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isHover: false,
            guildPopup: guider.display()
        };
        return _this;
    }
    RightDownload.prototype.render = function () {
        var _a = this.state, isHover = _a.isHover, guildPopup = _a.guildPopup;
        var themeInfo = this.props.themeInfo;
        var setting = themeInfo.setting;
        return (React.createElement("div", { className: "p-header__main__cnt__right__item p-header__main__cnt__right__item--download " + (setting.download.inPromotion ? 'p-header__main__cnt__right__item--download-promotion' : ''), onMouseEnter: this.onMouseEnter.bind(this), onMouseLeave: this.onMouseLeave.bind(this) },
            React.createElement("a", { className: "p-header__main__cnt__right__item__tl " + (setting.header.downloadGuide.enable ? 'p-header__main__cnt__right__item__tl--showtips' : ''), href: "//www.yy.com/download", target: "_blank" },
                React.createElement("i", { className: "p-header__main__cnt__right__item__tl__icon" }),
                React.createElement("span", { className: "p-header__main__cnt__right__item__tl__t" }, "\u4E0B\u8F7D"),
                React.createElement("span", { className: "p-header__main__cnt__right__item__tl__tips" }, setting.header.downloadGuide.tips)),
            React.createElement("div", { className: "p-header__drag p-header__drag__download " + (isHover && !guildPopup ? 'p-header__drag--show' : '') },
                React.createElement("span", { className: "p-header__drag__enterstage" },
                    React.createElement("i", { className: "p-header__drag__enterstage__tri" }),
                    React.createElement("i", { className: "p-header__drag__enterstage__tri2" })),
                React.createElement("div", { className: "p-header__drag__main" },
                    React.createElement("div", { className: "p-header__download" },
                        React.createElement("a", { className: "p-header__download__qrbox p-header__download__qrbox__s1", href: setting.download.flink.link, target: "_blank" },
                            React.createElement("span", { className: "p-header__download__qrbox__tl" }, setting.download.flink.title),
                            React.createElement("span", { className: "p-header__download__qrbox__sub" }, setting.download.flink.sub),
                            React.createElement("img", { className: "p-header__download__qrbox__img", src: setting.download.flink.qrcode, alt: "" })),
                        React.createElement("a", { className: "p-header__download__qrbox p-header__download__qrbox__s2", href: setting.download.mobileYY.link + "?f=3010", target: "_blank", onClick: function () { return stat_1.stat(stat_1.EStatType.DOWNLOAD_ITEM_CLICK, ['mobileYY']); } },
                            React.createElement("span", { className: "p-header__download__qrbox__tl" }, setting.download.mobileYY.title),
                            React.createElement("span", { className: "p-header__download__qrbox__sub" }, setting.download.mobileYY.sub),
                            React.createElement("img", { className: "p-header__download__qrbox__img", src: setting.download.mobileYY.qrcode, alt: "" })),
                        React.createElement("div", { className: "p-header__download__links" },
                            React.createElement("a", { className: "p-header__download__links__item", href: "//www.yy.com/yy8/", target: "_blank", onClick: function () { return stat_1.stat(stat_1.EStatType.DOWNLOAD_ITEM_CLICK, ['pc']); } }, "YY PC\u5BA2\u6237\u7AEF"),
                            React.createElement("a", { className: "p-header__download__links__item", href: "//www.yy.com/index/t/download", target: "_blank", onClick: function () { return stat_1.stat(stat_1.EStatType.DOWNLOAD_ITEM_CLICK, ['soft']); } }, "\u8F6F\u4EF6\u4E0B\u8F7D\u4E2D\u5FC3"))))),
            React.createElement("div", { className: "p-header__drag p-header__drag__download_guide " + (isHover && guildPopup ? 'p-header__drag--show' : '') },
                React.createElement("span", { className: "p-header__drag__enterstage" },
                    React.createElement("i", { className: "p-header__drag__enterstage__tri" }),
                    React.createElement("i", { className: "p-header__drag__enterstage__tri2" })),
                React.createElement("div", { className: "p-header__drag__main" },
                    React.createElement("a", { className: "p-header__drag__close", href: "javascript:;", onClick: this.onGuideClose.bind(this) }),
                    React.createElement("div", { className: "p-header__drag__download_guide__s1" }, setting.download.flink.title),
                    React.createElement("div", { className: "p-header__drag__download_guide__s2" }, setting.download.flink.sub),
                    React.createElement("a", { className: "p-header__drag__download_guide__s3", href: setting.download.flink.link, target: "_blank" },
                        React.createElement("img", { src: setting.download.flink.qrcode, width: "114", height: "114" }))))));
    };
    RightDownload.prototype.onMouseEnter = function () {
        this.setState({
            isHover: true
        });
    };
    RightDownload.prototype.onMouseLeave = function () {
        this.setState({
            isHover: false,
            guildPopup: false
        });
        guider.mark();
    };
    RightDownload.prototype.onGuideClose = function () {
        this.setState({
            guildPopup: false
        });
    };
    return RightDownload;
}(React.Component));
exports.RightDownload = RightDownload;
